export type AVAILABLE_METER_SIZE = 15 | 45 | 100 | 150;
export type AVAILABLE_MCB_SIZE = 16 | 50 | 100 | 150;
export type AVAILABLE_POLE_SIZE = 10 | 16 | 20 | 32 | 40 | 50 | 63;
export const METER_SIZE_LABEL_MAPPER = {
  15: '5/(15)',
  45: '15/(45)',
  100: '30/(100)',
  150: '50/(150)'
};
